export default __webpack_public_path__ + "610f118762aa1b740942d3211b5de7fb.svg";